import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { BackupTransactionType } from '../enums/backupTransationType'

interface GetBackupItemsProps {
  t: TFunction
  isSourceZervant: boolean
}

export const getBackupItems = ({ t, isSourceZervant }: GetBackupItemsProps) => {
  const items: NavItem<BackupTransactionType>[] = [
    {
      children: t('exports.card.backup.items.label.all'),
      id: BackupTransactionType.All,
      value: BackupTransactionType.All,
    },
    {
      children: t('exports.card.backup.items.label.bills'),
      id: BackupTransactionType.Bill,
      value: BackupTransactionType.Bill,
    },
    {
      children: t('exports.card.backup.items.label.payments'),
      id: BackupTransactionType.BankPayment,
      value: BackupTransactionType.BankPayment,
    },
  ]

  if (isSourceZervant) {
    items.push({
      children: t('exports.card.backup.items.label.invoices'),
      id: BackupTransactionType.ExternalInvoice,
      value: BackupTransactionType.ExternalInvoice,
    })
  } else {
    items.push({
      children: t('exports.card.backup.items.label.invoices'),
      id: BackupTransactionType.Invoice,
      value: BackupTransactionType.Invoice,
    })
  }

  return { items }
}
